import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import { getEventScheduleTokenFormUrl, downloadForm, getBookPersonalFormUrl, submitMaterials, cancelMaterials } from "@/api/event";
import { handleSSOLogin } from "@/utils/sso-login";
import { clearToken, getStoreToken } from "@/utils/token";
import { Download, DocumentChecked, DocumentRemove } from "@element-plus/icons-vue";
import axios from "axios";
export default {
  name: "Activity",
  components: {
    Download,
    DocumentChecked,
    DocumentRemove
  },
  mixins: [],
  props: {
    userSubmitFlag: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      iframeUrl: "",
      activeTab: "table",
      uploadUrl: `${process.env.VUE_APP_BASE_API}/front/upload/uploadFile`,
      token: getStoreToken(),
      applyForm: {
        eventId: this.$route.query.eventId,
        scheduleId: this.$route.query.scheduleId
      },
      loading: false,
      isDisabled: false,
      isLoading: false,
      isEnd: false,
      n: this.$route.query.n,
      loadingBack: false
    };
  },
  computed: {
    isCanSubmit() {
      return this.userSubmitFlag == 1;
    }
  },
  watch: {},
  created() {
    // if (!getStoreToken()) {
    //   handleSSOLogin();
    // } else {
    this.iframeUrl = "";
    if (this.$route.query.joinFlag != 1 && (this.$route.query.n == 2 || this.$route.query.n == 3 || this.$route.query.n == 1 || this.$route.query.n == 4)) {
      this.isEnd = true;
      return;
    }
    this.isEnd = false;
    if (this.$route.query.scheduleId && this.$route.path == "/activity" && this.$route.query.scheduleType == 1) {
      this.getEventScheduleToken(this.$route.query.scheduleId);
    } else if (this.$route.query.scheduleId && this.$route.path == "/activity" && this.$route.query.scheduleType == 2) {
      this.getBookPersonalFormUrl(this.$route.query.scheduleId, this.$route.query.scheduleName);
    }
    // }
  },
  beforeRouteUpdate(to, from, next) {
    console.log(to.query.n, "to.query.n", this.userSubmitFlag);
    if (to.query.joinFlag != 1 && (to.query.n == 2 || to.query.n == 3 || to.query.n == 1 || to.query.n == 4)) {
      this.isEnd = true;
      this.n = to.query.n;
      next();
      return;
    }
    this.isEnd = false;
    this.isDisabled = false;
    if (to.query.scheduleId !== from.query.scheduleId) {
      this.iframeUrl = "";
      if (to.query.scheduleType == 1) {
        this.getEventScheduleToken(to.query.scheduleId);
      } else if (to.query.scheduleType == 2) {
        console.log(111, to, "meta");
        if (to.query.scheduleName == "网评材料上传") {
          this.activeTab = "table";
        } else {
          this.activeTab = "meta";
        }
        console.log(222, this.activeTab, "meta");
        this.getBookPersonalFormUrl(to.query.scheduleId, to.query.scheduleName);
      }
    }
    next();
  },
  mounted() {},
  methods: {
    handleBack() {
      this.$confirm("确定撤回资料吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(async () => {
        this.loadingBack = true;
        let res = await cancelMaterials({
          eventId: this.$route.query.eventId,
          scheduleId: this.$route.query.scheduleId
        });
        if (res.code == 200) {
          this.$message.success("撤回资料成功");
          this.isDisabled = false;
          this.$emit("refresh");
          this.getBookPersonalFormUrl(this.$route.query.scheduleId, this.$route.query.scheduleName);
        }
        this.loadingBack = false;
      });
    },
    async submitMaterials() {
      this.$confirm("确定提交资料吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(async () => {
        this.loading = true;
        let res = await submitMaterials({
          eventId: this.$route.query.eventId,
          scheduleId: this.$route.query.scheduleId
        });
        if (res.code === 200) {
          this.$message.success("提交成功");
          this.isDisabled = true;
          this.$emit("refresh");
          this.getBookPersonalFormUrl(this.$route.query.scheduleId, this.$route.query.scheduleName);
        }
        this.loading = false;
      });
    },
    async getEventScheduleToken(scheduleId) {
      let res = await getEventScheduleTokenFormUrl(scheduleId);
      if (res.code === 401) {
        clearToken();
        handleSSOLogin();
      } else if (res.code == 200) {
        this.iframeUrl = res.data ? res.data.formUrl : "";
      }
    },
    async getBookPersonalFormUrl(scheduleId, scheduleName) {
      console.log(this.$route.query.scheduleName, "meta");
      this.isLoading = true;
      setTimeout(() => {
        this.isLoading = false;
      }, 500);
      let res = await getBookPersonalFormUrl({
        scheduleId,
        type: scheduleName == "网评材料上传" ? this.activeTab : "meta"
      });
      if (res.code === 401) {
        clearToken();
        handleSSOLogin();
      } else if (res.code == 200) {
        this.iframeUrl = res.data || "";
      }
    },
    onChangeTab(tab) {
      this.activeTab = tab;
      this.getBookPersonalFormUrl(this.$route.query.scheduleId, this.$route.query.scheduleName);
    },
    adjustIframeHeight() {
      const iframe = this.$refs.activityIframe;
      if (iframe) {
        console.info(iframe);
        // const contentWindow = iframe.contentWindow;
        // const contentDocument = contentWindow.document;
        // const height = Math.max(
        //   contentDocument.body.scrollHeight,
        //   contentDocument.documentElement.scrollHeight,
        //   contentDocument.body.offsetHeight,
        //   contentDocument.documentElement.offsetHeight,
        //   contentDocument.body.clientHeight,
        //   contentDocument.documentElement.clientHeight
        // );
        // iframe.style.height = `${Math.max(height, 1000)}px`;
      }
    },
    handleSSOLogin() {
      handleSSOLogin();
    },
    // 处理文件下载
    handleDownload() {
      downloadForm(this.$route.query.scheduleId).then(res => {
        if (res.code == 200) {
          console.log(res.data);
          if (res.data) {
            // window.open(res.data);
            window.parent.location.href = res.data;
            // this.previewFile(res.data)
          }
        }
      });
    },
    handleNoticeClick() {
      if (process.env.VUE_APP_FILE_UPDATE_NOTICE_URL2) {
        window.open(process.env.VUE_APP_FILE_UPDATE_NOTICE_URL2, "_blank");
      }
    },
    handleUpload() {},
    async previewFile(file) {
      try {
        const response = await axios.get(file, {
          responseType: "blob",
          headers: {
            token: this.token
          }
        });
        const blob = new Blob([response.data]);
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = "下载文件";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(link.href);
      } catch (e) {
        this.$message.error("下载失败");
      }
    }
  }
};